import {useLayoutEffect, useRef} from 'react'
import {useLocation} from 'react-router-dom'

const isPDP = (path) => /^\/product\/[\w-]+$/.test(path)

/**
 * Custom ScrollToTop that prevents scroll reset during PDP swatch navigation.
 * Only preserves scroll when navigating between product detail pages (swatch changes).
 */
export default function ScrollToTop() {
    const {pathname} = useLocation()
    const previousPathRef = useRef(null)

    useLayoutEffect(() => {
        const isSwatchNavigation =
            previousPathRef.current && isPDP(previousPathRef.current) && isPDP(pathname)

        if (!isSwatchNavigation) {
            queueMicrotask(() => {
                requestAnimationFrame(() => window.scrollTo({top: 0, behavior: 'instant'}))
            })
        }

        previousPathRef.current = pathname
    }, [pathname])

    return null
}
